import React from 'react';
import { Outlet } from 'react-router';
import { SUBSCRIBER_PATH } from '../../../../constants';
const Reporting = React.lazy(() => import('./index'));
const CompletionReports = React.lazy(() => import('./completionReports'));

const Routes = {
     path: SUBSCRIBER_PATH.ORGANIZATIONS_REPORTING,
     breadcrumb: 'Reporting',
     element: <Outlet />,
     children: [
          { index: true, element: <Reporting /> },
          {
               path: SUBSCRIBER_PATH.ORGANIZATIONS_REPORTING_COMPLETION_REPORT,
               breadcrumb: 'Completion Report',
               element: <CompletionReports />,
          },
     ],
};

export default Routes;
